export const actionTypes = {
  REQUEST_START: 'TAPS.2NDFL.LIST.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.2NDFL.LIST.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.2NDFL.LIST.REQUEST_FAILURE',
  NDFL_2_USE_ADD: 'TAPS.2NDFL.LIST.USE_ADD',
  NDFL_2_USE_REMOVE: 'TAPS.2NDFL.LIST.USE_REMOVE',
};

export function startRequest(year, ids) {
  return {
    type: actionTypes.REQUEST_START,
    ids,
    year,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function ndfl2UseAdd(ids) {
  return {
    type: actionTypes.NDFL_2_USE_ADD,
    ids,
  };
}

export function ndfl2UseRemove(origin) {
  return {
    type: actionTypes.NDFL_2_USE_REMOVE,
    origin,
  };
}
